module.exports = __webpack_public_path__ + "static/media/read_content_aloud_urdu.a19e9b53.mp3";